<template>
    <input type="password" autocomplete="new-password" v-if="isNew || editMode" :value="value" @change="$emit('change', $event.target.value)" @blur="onBlur" :required="required" />
    <input type="text" v-else-if="isEntered" :placeholder="translate('password.passwordSet')" @focus="editMode = true" class="is-valid" />
    <input type="text" v-else :placeholder="translate('password.clickToSetNewPassword')" @focus="editMode = true" />
    <!-- <div role="input" v-else>
        <input type="text" style="opacity:0.5; display:block; position:absolute" />
        *********
    </div> -->
    <!-- <div>editMode: {{editMode}}</div>
    <div>value: {{value}}</div> -->
</template>
<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type:String
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            editMode: false
        }
    },
    methods: {
        onBlur($event){
            console.log('onBlur', $event);
            this.$emit('change', $event.target.value);
            this.editMode = false;
        }
    },
    computed:{
        isNew(){
            // Sadece null ise yeni giriştir. Empty String, daha önce parola gilirmiş ancak server'dan client'e dönülmemiş demektir.
            return this.value == null;
        },
        isEntered(){
            return this.value != null;
        }
    }
}
</script>
